import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const PrometheusIntegration = React.lazy(() => import("./PrometheusIntegration"));

interface PrometheusIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function PrometheusIntegrationLazy(props: PrometheusIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <PrometheusIntegration {...props} />
    </Suspense>
  );
}
